import { createContext, useContext } from "react"
import type { CurrencyCode } from "@silversea-ssc/dotcom-read-model-types/Currency"
import { UnitSystem } from "@ssc-booking/api-contracts"

export interface Geolocation {
    countryCode: string
    defaultCurrency: CurrencyCode
    market: string
    phone?: string
    unit: UnitSystem
    countryPath: string
}

export const defaultGeoLocation: Geolocation = {
    countryCode: "US",
    defaultCurrency: "USD",
    market: "FT",
    phone: undefined,
    unit: "feet",
    countryPath: "FT/USA/US",
}

export const GeolocationContext = createContext<Geolocation>(defaultGeoLocation)

export function useGeolocation(): Geolocation {
    return useContext(GeolocationContext)
}
